import React from 'react'
import ErrorSrc from '../img/error.png'
import { withRouter } from 'react-router-dom'
import * as Sentry from '@sentry/browser'
import Layout from './Layout'
import { Typography } from '@material-ui/core'
import DocStore from '../stores/DocStore'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch (error, info) {

    this.setState({ hasError: true })
    this.setState({ error })
    Sentry.withScope(scope => {
      scope.setExtras({...info, email:DocStore.email(),path:window.location.href})
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    })
  }

  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({ hasError: false })
    }
  }


  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Layout showPaper={false}>
          <div>
            <img style={{width:'93px'}} src={ErrorSrc} alt='error' className='' />
              <Typography variant={"h6"} style={{ color: "#888883", margin: "1em" }}>
                <span>Algo ha salido mal, esta página no funciona.</span>
              </Typography>
         </div>
        </Layout>
      )
    }
    return this.props.children
  }
}

export default withRouter(ErrorBoundary)



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js